import React, { useCallback, useContext, useEffect, useState } from "react";
import moment from "moment";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import CustomerDetailsForm from "./indexForm";
import isEmail from "validator/lib/isEmail";
import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import { ReducerUtils } from "../../../constants/reducers";
import { Box } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../../helpers/utils";
import { buildVerifyPancardPayload } from "../../../helpers/proposal";
import { useHistory } from "react-router";
import { Utils } from "../../../constants/utils";
import { getWebService, postWebService } from "../../../helpers/server";
import { validations } from "../../../messages/validation";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import {
  buildUpdateCustomerPayload,
  reBuildStateCityList,
} from "../../../helpers/customer";
import {
  accordianObject,
  autoCompleteObject,
  errorMessageObject,
  formObject,
  touchFieldObject,
} from "../../../defaultValues/customer";
import {
  MESSAGE_SEND_AADHAAR_OTP,
  SLUG_TERM_PRODUCT,
  SLUG_TROP_PRODUCT,
} from "../../../constants/index";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function CustomerDetails({ classes: { loaderBox, main } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [backdrop, setBackdrop] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ ...errorMessageObject });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...formObject });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    snackbar: false,
    panMismatch: false,
  });
  const [touchFields, setTouchFields] = useState({ ...touchFieldObject });
  const [accordian, setAccordian] = useState({ ...accordianObject });
  const [selectedCityOption, setSelectedCityOption] = useState({
    ...autoCompleteObject,
  });
  const [selectedStateOption, setSelectedStateOption] = useState({
    ...autoCompleteObject,
  });
  const [cibilConfig, setCibilConfig] = useState(null);
  const [configLoaded, setConfigLoaded] = useState(false);
  const [isCibilEnabled, setIsCibilEnabled] = useState(0);
  const [capturePan, setCapturePan] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [captureFatherName, setCaptureFatherName] = useState(false);
  const [panErrorMessage, setPanErrorMessage] = useState("");
  const [isPanVerifiedError, setIsPanVerifiedError] = useState(false);
  const [panDetails, setPanDetails] = useState(null);

  useEffect(() => {
    async function fetchCustomerDetails() {
      try {
        const response = await postWebService("customer-details.php", {
          oid: Number(getStorageItem("oid")),
        });

        setCustomerDetails(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    async function fetchStates() {
      try {
        const response = await getWebService("getstates.php");

        const { data = [] } = response.data;
        dispatchEvent(ReducerUtils.state.list, reBuildStateCityList(data));
      } catch (error) {
        // console.log(error);
      }
    }

    async function fetchCities() {
      try {
        const response = await getWebService("getcities.php");

        const { data = [] } = response.data;
        dispatchEvent(ReducerUtils.city.list, reBuildStateCityList(data));
      } catch (error) {
        // console.log(error);
      }
    }

    async function validateIIBScore() {
      try {
        const response = await postWebService("checkiibstatus.php", {
          oid: Number(getStorageItem("oid")),
        });

        let dataSlice = response.data.data.slice(9);
        dataSlice = dataSlice.slice(0, -8);

        const data = JSON.parse(atob(dataSlice));

        if (data.code == 200) {
          var status = data.data.status ?? null;
          var reason =
            data.data.reason ?? "Journey terminated due IIB vadilation.";
          if (status === false) {
            setStorageItem("journeyCloseReason", reason);
            navigateTo("terminated");
          } else {
            // console.log("iib score okay");
          }
        }
      } catch (error) {
        cbError(error);
      }
    }

    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        setStorageItem("access-token", response.data.access_token);

        await validateIIBScore();
        await fetchStates();
        await fetchCities();
        await fetchCustomerDetails();
        await fetchAppConfig();
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);

  useEffect(() => {
    isLoaded &&
      customerDetails &&
      orderDetails &&
      cbSuccessCustomerDetails(customerDetails, orderDetails);
  }, [isLoaded, customerDetails, orderDetails]);

  const fetchAppConfig = useCallback(async () => {
    try {
      const partnerid = getStorageItem("partnerId");
      const response = await postWebService("app_config.php", { partnerid });
      const { data } = response;
      const config = data.CIBIL ? JSON.parse(data.CIBIL) : null;
      const supportedProductIds = config?.supported_product_ids ?? [];
      const productId = getStorageItem("pid")
        ? Number(getStorageItem("pid"))
        : "";
      const cibilEnabled = config?.cibil_integration ?? 0;
      const shouldCapturePan =
        config?.cibil_input === "pan_number" &&
        supportedProductIds.includes(productId);
      const supportedFatherNameProductIds =
        config?.capture_father_name_product_ids_exception ?? [];

      setCaptureFatherName(!supportedFatherNameProductIds.includes(productId));
      setCibilConfig(config);
      setConfigLoaded(true);
      setIsCibilEnabled(cibilEnabled);
      setCapturePan(shouldCapturePan);

      // cibilEnabled && shouldCapturePan ? fetchPANViaMobile() : getOrder();
      fetchPANViaMobile();
    } catch (error) {
      setBackdrop(false);
    }
  }, []);

  const fetchPANViaMobile = useCallback(async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("mobiletopan.php", {
        checksum,
        oid: getStorageItem("oid"),
      });
      const { data } = response;
      const str = data.data.slice(9, -8);
      const dataApi = JSON.parse(atob(str));
      dataApi.status === 200 && dataApi.checksum === checksum
        ? getOrder()
        : setBackdrop(false);
    } catch (error) {
      setBackdrop(false);
    }
  }, []);

  const getOrder = useCallback(async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("orders.php", {
        checksum,
        oid: getStorageItem("oid"),
      });
      const { data } = response;
      setBackdrop(false);
      const str = data.data.slice(9, -8);
      const result = JSON.parse(atob(str));
      if (result.checksum === checksum) {
        setOrderDetails(result);
        setIsLoaded(true);
        if (result?.skip_cibil) {
          setIsCibilEnabled(0);
          setCapturePan(false);
        }
      }
    } catch (error) {
      setBackdrop(false);
    }
  }, []);

  const cbSuccessCustomerDetails = (
    { address, dob, email, gender, mobile, name } = {},
    {
      is_pan_verified,
      panNumber,
      fatherName = "",
      is_dedupe_pan = 0,
      pan_required = 0,
    } = {}
  ) => {
    setForm({
      ...form,
      address,
      dob: moment(dob, "DD/MM/YYYY").format("YYYY-MM-DD"),
      email,
      gender,
      mobile,
      name,
      ...(panNumber && { pan_number: panNumber }),
      ...(is_pan_verified && {
        verify_pan_number: is_pan_verified ? true : false,
      }),
      ...(captureFatherName && { father_name: fatherName }),
      dedupePan: is_dedupe_pan == 1,
      panRequired: pan_required == 1,
      captureFatherName,
    });
  };

  useEffect(() => {}, [selectedCityOption]);

  useEffect(() => {}, [selectedStateOption]);

  useEffect(() => validateEmail("email"), [form.email]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleAccordianClick = (section, flag) => {
    const shallowCopy = { ...accordian };
    for (const key in shallowCopy) {
      if (section != key) {
        shallowCopy[key] = false;
      }
    }

    shallowCopy[section] = !flag;

    setAccordian(shallowCopy);
  };

  const handleBack = () => navigateTo("ekyc");

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleChangeChipSelect = (name, value) => setFormState(name, value);

  const handleClick = () =>
    navigateTo(getStorageItem("tabIndex") === "1" ? "declaration" : "payment");

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const navigateTo = (url = "payment") => {
    url = getPathName(url);

    history.push({ pathname: getRoute(url) });
  };

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const validateEmail = (fieldName) => {
    if (form[fieldName]) {
      let isValid = isEmail(form[fieldName]);
      setStateVariables(
        fieldName,
        isValid,
        isValid ? "" : validations[fieldName].valid
      );
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, "");
    }
  };

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateInputLength = (event) => {
    let elName = event.target.name;
    let elValue = event.target.value;

    if (event.target.name === "mobile") {
      var clean = elValue.replace(/[^0-9]+/g, "");
      event.target.value = clean;
    }

    if (elValue.length > Utils.limit.digits[elName]) {
      event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
    }
  };

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const toggleModal = (keyname = "open", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setBackdrop(false);

    setErrors(new Array(error));
  };

  const updateOrderDetails = async (url = "bankDetails") => {
    try {
      const response = await postWebService("update-order.php", {
        oid: getStorageItem("oid"),
        status: "EKYC",
      });

      setIsFormSubmitted(false);
      setBackdrop(false);
      response.data.code === 201
        ? navigateTo(url)
        : setErrors(new Array(response.data.msg));
    } catch (error) {
      cbError(error);
    }
  };

  const updateCustomerDetails = async () => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService(
        "update-customer.php",
        buildUpdateCustomerPayload(
          form,
          selectedStateOption,
          selectedCityOption
        )
      );

      if (response.data.code === 200) {
        isCibilEnabled ? fetchCibilScore() : updateOrderDetails();
      } else {
        setIsFormSubmitted(false);
        setBackdrop(false);
      }
    } catch (error) {
      cbError(error);
    }
  };

  /* Start: CIBIL Section */
  const idvSuccessError = ({ data }, checksum) => {
    var str = data.data.slice(9);
    str = str.slice(0, -8);
    var dataApi = JSON.parse(atob(str));
    if (dataApi.checksum == checksum) {
      if (dataApi.status == 200) {
        updateOrderDetails(
          getStorageItem("productSlug") === SLUG_TERM_PRODUCT
            ? "regenerateBI"
            : "bankDetails"
        );
      } else if (dataApi.status == 401) {
        terminateJourneyHandler(data?.message);
      } else if (dataApi.status == 422) {
        updateOrderDetails("financialUnderwriting");
      } else {
        cbError(dataApi?.message ?? "Error in IDV calculation");
      }
    } else {
      cbError("Error in IDV calculation");
    }
  };

  const fetchIDV = async () => {
    try {
      setErrors([]);
      const checksum = makeid();
      const response = await postWebService("idv.php", {
        oid: Number(getStorageItem("oid")),
        checksum,
      });

      idvSuccessError(response, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const cibilSuccess = (data = null) => {
    const newToCredit = data?.new_to_credit ?? false;

    newToCredit
      ? fetchIDV()
      : updateOrderDetails(
          getStorageItem("productSlug") === SLUG_TERM_PRODUCT
            ? "regenerateBI"
            : "bankDetails"
        );
  };

  const cibilSuccessError = ({ data }, checksum) => {
    setIsFormSubmitted(false);

    // 200 => Success, 422 => Validation Error in API, 400 => Fail
    if (data?.status == 200 && data?.checksum == checksum) {
      cibilSuccess(data);
    } else if (data?.status == 422 && data?.checksum == checksum) {
      cbError(data?.message);
    } else {
      terminateJourneyHandler(data?.message);
    }
  };

  const fetchCibilScore = async () => {
    try {
      setErrors([]);
      const checksum = makeid();
      const response = await postWebService("cibil.php", {
        oid: Number(getStorageItem("oid")),
        checksum,
      });

      cibilSuccessError(response, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessVerifyPancardDetailsPerfios = ({ data }, checksum) => {
    setIsFormSubmitted(false);
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);
    const dataJSON = JSON.parse(atob(dataSlice));
    if (dataJSON.code == 200 && dataJSON.checksum == checksum) {
      const isValid = dataJSON.isValid ?? null;
      setForm({
        ...form,
        verify_pan_number: isValid ? true : false,
      });
      setIsFormSubmitted(false);
      !isValid && toggleModal("pancard", true);
    } else {
      setForm({
        ...form,
        verify_pan_number: false,
      });
      setIsFormSubmitted(false);
      toggleModal("pancard", true);
    }
  };

  const verifyPancardDetailsPerfios = async () => {
    try {
      setIsFormSubmitted(true);

      const checksum = makeid();
      const response = await postWebService(
        "verifyPANdetails.php",
        buildVerifyPancardPayload(form, checksum)
      );

      cbSuccessVerifyPancardDetailsPerfios(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const validPanDetailsHandler = (dataJSON = null) => {
    const isValid = dataJSON.isValid ?? false;
    const data = dataJSON?.data ?? null;

    setPanDetails(data);
    setModal({ ...modal, panMismatch: isValid && data });
    setIsPanVerifiedError(!isValid);
    setForm({
      ...form,
      verify_pan_number: isValid ? true : false,
    });

    !isValid && toggleModal("pancard", true);
  };

  const inValidPanDetailsHandler = (dataJSON = null) => {
    const message =
      dataJSON?.message ?? "Error in PAN Verification. Please try again.";
    setIsPanVerifiedError(true);
    setPanErrorMessage(message);

    if (dataJSON?.code == 403) {
      terminateJourneyHandler(dataJSON?.message);
    }
  };

  const handleCheckboxChange = (event) =>
    setFormState([event.target.name], event.target.checked);

  const cbSuccessVerifyPancardDetails = ({ data }, checksum) => {
    setIsFormSubmitted(false);

    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);
    const dataJSON = JSON.parse(atob(dataSlice));
    if (dataJSON.checksum == checksum) {
      dataJSON.code == 200
        ? validPanDetailsHandler(dataJSON)
        : inValidPanDetailsHandler(dataJSON);
    } else {
      inValidPanDetailsHandler(
        dataJSON,
        "Invalid Checksum Received: Not able to process this request."
      );
    }
  };

  const verifyPancardDetails = async () => {
    try {
      setIsFormSubmitted(true);
      setPanErrorMessage("");
      const checksum = makeid();
      const response = await postWebService(
        "verifypan.php",
        buildVerifyPancardPayload(form, checksum)
      );

      cbSuccessVerifyPancardDetails(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const terminateJourneyHandler = (message = "") => {
    setStorageItem("journeyCloseReason", message);
    navigateTo("terminated");
  };
  /* End: CIBIL Section */

  // const isDedupeEnabled = () => orderDetails?.productSlug === SLUG_TROP_PRODUCT;

  const isDedupeEnabled = () => {
    return true;
  };

  const getPathName = (pathname = "bankDetails") =>
    isDedupeEnabled() && pathname === "bankDetails" ? "dedupe" : pathname;

  const onSubmit = (event) => {
    event.preventDefault();

    updateCustomerDetails();
  };

  return isLoaded && state?.cities.length > 0 && state?.states.length > 0 ? (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1} mb={0}>
          <SectionTitle
            title={"KYC Verification"}
            onClickHandler={handleBack}
          />
        </Box>

        <CustomerDetailsForm
          accordian={accordian}
          backdrop={backdrop}
          capturePan={capturePan}
          errorMessage={errorMessage}
          errors={errors}
          form={form}
          handleAccordianClick={handleAccordianClick}
          handleChange={handleChange}
          handleChangeChipSelect={handleChangeChipSelect}
          handleClose={handleClose}
          handleCheckboxChange={handleCheckboxChange}
          isFormSubmitted={isFormSubmitted}
          modal={modal}
          panDetails={panDetails}
          panErrorMessage={panErrorMessage}
          isPanVerifiedError={isPanVerifiedError}
          handleClick={handleClick}
          onSubmit={onSubmit}
          orderDetails={orderDetails}
          cities={state.cities}
          states={state.states}
          selectedCityOption={selectedCityOption}
          setSelectedCityOption={setSelectedCityOption}
          selectedStateOption={selectedStateOption}
          setSelectedStateOption={setSelectedStateOption}
          validateInputLength={validateInputLength}
          verifyPancardDetails={verifyPancardDetails}
        />

        {modal.snackbar && (
          <NotificationMessage
            open={modal.snackbar}
            message={MESSAGE_SEND_AADHAAR_OTP}
            onClose={() => handleClose("snackbar", false)}
          />
        )}
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerDetails);
